// import React, { useEffect, useRef, useState } from 'react';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import './ContactFormWithMap.css';
// import { useTranslation } from 'react-i18next';
// import axios from 'axios';
// import { BASE_URL } from '../../Services/courseService';
// import { toast } from 'react-toastify';
// import { ClipLoader } from 'react-spinners';
// import 'font-awesome/css/font-awesome.min.css';

// const ContactFormWithMap = () => {
//   const mapContainerRef = useRef(null);
//   const { t } = useTranslation();

//   const userId = localStorage.getItem('userId');
//   const token = localStorage.getItem('token');
//   const [subject, setSubject] = useState('');
//   const [description, setDescription] = useState('');
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const markerPosition = [17.4416, 78.3825];
//     const map = L.map(mapContainerRef.current).setView(markerPosition, 15);

//     L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
//       attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors & <a href="https://carto.com/attributions">CartoDB</a>',
//       maxZoom: 19
//     }).addTo(map);

//     const customIcon = L.icon({
//       iconUrl: 'https://e7.pngegg.com/pngimages/409/413/png-clipart-map-drawing-pin-map-marker-angle-heart.png',
//       iconSize: [32, 32],
//       iconAnchor: [16, 32],
//       popupAnchor: [0, -32]
//     });

//     const marker = L.marker(markerPosition, { icon: customIcon }).addTo(map)
//       .bindPopup('PRT SOFTWARE SOLUTIONS')
//       .openPopup();

//     marker.on('click', () => {
//       window.open(`https://www.google.com/maps?q=${markerPosition[0]},${markerPosition[1]}`, '_blank');
//     });

//     map.on('click', () => {
//       window.open(`https://www.google.com/maps?q=${markerPosition[0]},${markerPosition[1]}`, '_blank');
//     });

//     return () => {
//       map.remove();
//     };
//   }, []);

//   const userName = localStorage.getItem('fullName');
//   const email = localStorage.getItem('email');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     toast.dismiss();

//     if (!userId) {
//       toast.error('Please log in to create the ticket');
//       return;
//     }
//     setLoading(true);

//     const newTicket = { subject, description, userId: parseInt(userId), userName: userName, userEmail: email };

//     try {
//       await axios.post(`${BASE_URL}/tickets`, newTicket, {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       });
//       toast.dismiss();

//       toast.success('Ticket created successfully!');
//       setSubject('');
//       setDescription('');
//     } catch (error) {
//       toast.dismiss();

//       toast.error('Error creating ticket');
//       console.error('Error creating ticket:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="contact-section">
//       <div className="contact-form">
//         <h2>{t('ContactUs')}</h2>
//         <form onSubmit={handleSubmit}>
//           <p>{t('HelpMessage')}</p>

//           <input
//             type="text"
//             placeholder={t('SubjectPlaceholder')}
//             value={subject}
//             onChange={(e) => setSubject(e.target.value)}
//             required
//           />
//           <textarea
//             placeholder={t('DescriptionPlaceholder')}
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             required
//           />
//           <button type="submit">
//             {loading ? (
//               <ClipLoader color="white" loading={loading} size={14} />
//             ) : (
//               t('SubmitButton')
//             )}
//           </button>
//         </form>
//       </div>
//       <div className="address-map-container">
//         <div className='address-contact'>
//           <p>
//             <i className="fa fa-phone" style={{ marginRight: '8px' }}></i>
//             +917569400921
//           </p>
//           <a href="mailto:support@skillzverse.com">
//             <p>
//               <i className="fa fa-envelope" style={{ marginRight: '8px' }}></i>
//               support@skillzverse.com
//             </p>
//           </a>

//         </div>

//         <p>
//           <i className="fa fa-map-marker" style={{ marginRight: '8px' }}></i>
//           PRT SOFTWARE SOLUTIONS LLP, Serenity Square, 1-98/G/38, MindSpace, HITEC City, Hyderabad, Telangana 500081
//         </p>
//         <div ref={mapContainerRef} className="map"></div>
//       </div>
//     </div>
//   );
// };

// export default ContactFormWithMap;


import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './ContactFormWithMap.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { BASE_URL } from '../../Services/courseService';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import 'font-awesome/css/font-awesome.min.css';

const ContactFormWithMap = () => {
  const mapContainerRef = useRef(null);
  const { t } = useTranslation();

  const userId = localStorage.getItem('userId');
  const token = localStorage.getItem('token');
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  const markerPosition = [17.4416, 78.3825];
  const map = L.map(mapContainerRef.current).setView(markerPosition, 15);

  L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors & <a href="https://carto.com/attributions">CartoDB</a>',
    maxZoom: 19,
  }).addTo(map);

  const customIcon = L.icon({
    iconUrl:
      'https://e7.pngegg.com/pngimages/409/413/png-clipart-map-drawing-pin-map-marker-angle-heart.png',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

  const marker = L.marker(markerPosition, { icon: customIcon })
    .addTo(map)
    .bindPopup('PRT SOFTWARE SOLUTIONS')
    .openPopup();

  marker.on('click', () => {
    window.open(
      `https://www.google.com/maps?q=${markerPosition[0]},${markerPosition[1]}`,
      '_blank'
    );
  });

  map.on('click', () => {
    window.open(
      `https://www.google.com/maps?q=${markerPosition[0]},${markerPosition[1]}`,
      '_blank'
    );
  });

  // ✅ Social icons control
  const socialControl = L.control({ position: 'topright' });

  socialControl.onAdd = function () {
    const div = L.DomUtil.create('div', 'social-icons');
    div.innerHTML = `
      <a href="https://www.linkedin.com/company/skillzverse/posts/?feedView=all" target="_blank" rel="noreferrer" class="linkedin"><i class="fa fa-linkedin"></i></a>
      <a href="https://www.facebook.com/profile.php?id=61576705712792" target="_blank" rel="noreferrer" class="facebook"><i class="fa fa-facebook"></i></a>
      <a href="https://www.youtube.com/@SkillzVerse" target="_blank" rel="noreferrer" class="youtube"><i class="fa fa-youtube-play"></i></a>
      <a href="https://www.instagram.com/skillzverse_sv/" target="_blank" rel="noreferrer" class="instagram"><i class="fa fa-instagram"></i></a>
    `;

    L.DomEvent.disableClickPropagation(div);
    L.DomEvent.disableScrollPropagation(div);

    return div;
  };

  socialControl.addTo(map);

  return () => {
    map.remove();
  };
}, []);


  const userName = localStorage.getItem('fullName');
  const email = localStorage.getItem('email');

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();

    if (!userId) {
      toast.error('Please log in to create the ticket');
      return;
    }
    setLoading(true);

    const newTicket = {
      subject,
      description,
      userId: parseInt(userId),
      userName: userName,
      userEmail: email,
    };

    try {
      await axios.post(`${BASE_URL}/tickets`, newTicket, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.dismiss();

      toast.success('Ticket created successfully!');
      setSubject('');
      setDescription('');
    } catch (error) {
      toast.dismiss();

      toast.error('Error creating ticket');
      console.error('Error creating ticket:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-section">
      <div className="contact-form">
        <h2>{t('ContactUs')}</h2>
        <form onSubmit={handleSubmit}>
          <p>{t('HelpMessage')}</p>

          <input
            type="text"
            placeholder={t('SubjectPlaceholder')}
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
          <textarea
            placeholder={t('DescriptionPlaceholder')}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
          <button type="submit">
            {loading ? (
              <ClipLoader color="white" loading={loading} size={14} />
            ) : (
              t('SubmitButton')
            )}
          </button>
        </form>
      </div>
      <div className="address-map-container">
        <div className="address-contact">
          <p>
            <i className="fa fa-phone" style={{ marginRight: '8px' }}></i>
            +917569400921
          </p>
          <a href="mailto:support@skillzverse.com">
            <p>
              <i className="fa fa-envelope" style={{ marginRight: '8px' }}></i>
              support@skillzverse.com
            </p>
          </a>
        </div>

        <p>
          <i className="fa fa-map-marker" style={{ marginRight: '8px' }}></i>
          PRT SOFTWARE SOLUTIONS LLP, Serenity Square, 1-98/G/38, MindSpace,
          HITEC City, Hyderabad, Telangana 500081
        </p>
        <div ref={mapContainerRef} className="map"></div>
      </div>
    </div>
  );
};

export default ContactFormWithMap;
